import React from 'react';
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import { expertContext } from "../../../context/expertcontext";
import { useContext , useEffect} from 'react';
const ChangePass = () => {
  const {  setPage} = useContext(expertContext);

  useEffect(()=>{
    setPage("تغییر رمز")
  },[])
    return (
        <div className="expert-change-pass"  style={{paddingTop:"10px"}}>
        <Header />
        <div
          className="d-flex request-box-content"
          style={{ margin: "20px 30px 20px 30px" }}
        >
          <Menu />
        <div className='w-100'>
        <div className='row mt-5 w-100 justify-content-center' style={{height:"250px"}}>
        <div className='col-lg-7'>
        <input placeholder='رمز عبور قبلی' className='pass-input-style w-100' />
        </div>
        <div className='col-lg-7'>
        <input placeholder='رمز عبور جدید' className='pass-input-style w-100' />
        </div>
        <div className='col-lg-7'>
        <input placeholder='تکرار رمز عبور جدید ' className='pass-input-style w-100' />
        </div>
        </div>
        <div className=' request-Previous-btn-box mt-2 mx-auto '>
        <button className='btn request-Previous-btn ' type='button'>ثبت رمز جدید</button>
        </div>
        </div>
        </div>
      </div>
    );
};

export default ChangePass;